var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('el-date-picker',_vm._g(_vm._b({attrs:{"type":"date","placeholder":_vm.$t('other.select-date'),"editable":false,"value-format":"yyyyMMdd","picker-options":_vm.pickerOptions}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }